var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 28,
    viewBox: "0 0 20 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 27.3349C9.24444 27.3349 8.60556 27.0738 8.08333 26.5516C7.56111 26.0293 7.3 25.3904 7.3 24.6349H12.7C12.7 25.3904 12.4389 26.0293 11.9167 26.5516C11.3944 27.0738 10.7556 27.3349 10 27.3349ZM4.6 22.5682V20.5682H15.4V22.5682H4.6ZM4.76667 18.5349C3.3 17.5793 2.13889 16.3849 1.28333 14.9516C0.427778 13.5182 0 11.9016 0 10.1016C0 7.39045 0.988889 5.04601 2.96667 3.06823C4.94444 1.09045 7.28889 0.101562 10 0.101562C12.7111 0.101562 15.0556 1.09045 17.0333 3.06823C19.0111 5.04601 20 7.39045 20 10.1016C20 11.9016 19.5778 13.5182 18.7333 14.9516C17.8889 16.3849 16.7222 17.5793 15.2333 18.5349H4.76667ZM5.5 16.5349H14.5333C15.6 15.8238 16.4444 14.9016 17.0667 13.7682C17.6889 12.6349 18 11.4127 18 10.1016C18 7.90156 17.2167 6.01823 15.65 4.45156C14.0833 2.8849 12.2 2.10156 10 2.10156C7.8 2.10156 5.91667 2.8849 4.35 4.45156C2.78333 6.01823 2 7.90156 2 10.1016C2 11.4127 2.31111 12.6349 2.93333 13.7682C3.55556 14.9016 4.41111 15.8238 5.5 16.5349Z",
    fill: "#1C1C27"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIt);
export default __webpack_public_path__ + "static/media/it.27efea688ebb86ee4abfad90849a7f42.svg";
export { ForwardRef as ReactComponent };